export function parseFromTextToTextValueObject(comaSeparatedText, textValueObject) {
  const roleSubset = textValueObject.filter(role => comaSeparatedText && comaSeparatedText.indexOf(role.text) > -1);
  return roleSubset.map(role => ({ value: role.value, text: role.text }));
}
